'use client';

import './home-mobile.scss';
import React, { useEffect } from 'react';
import {MAIL_CONFIG} from '@/lib/config';
import ButtonRight from '@/components/layout/Desktop/SiderRight/ButtonRight';

interface Props {
  footerType: number;
}

export default function Reach(props: Props) {

  useEffect(() => {
    const handleScroll = (e: any) => {
      e.preventDefault();
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('scroll', handleScroll, {passive: false});

    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const _renderTextLoad = (title: string) => {
    return title
  };

  const _goList = () => {
    window.location.href = `mailto:${MAIL_CONFIG}`;
  };

  const _renderContent = () => {
    return (
      <div className='reach-container'>
        <p className='text-gray'>{`< Reach >`}</p>
        <p className='description-intro'>
          {_renderTextLoad('195 Pearl’s Hill Terrace #03-76 ')}
          {_renderTextLoad('Singapore 168976')}
        </p>
        <p className={'text-gray'}>{'< or >'}</p>
        <div style={{marginLeft: '-40px', marginTop: '5px'}}>
          <ButtonRight
            goList={_goList}
            size={200}
          />
        </div>
      </div>
    )
  };

  return (
    <div className={'div-loading-container'}>
      {_renderContent()}
    </div>
  )
}